<div *ngIf="isReady && !isHidden" class="gallery-parent" (click)="close()">
    <!--<div class="close">
        <mat-icon (click)="close()">highlight_off</mat-icon>
    </div>-->
    <div class="images-container">
        <div class="left-click" (click)="previousImage($event)"><mat-icon>chevron_left</mat-icon></div>
        <div class="right-click" (click)="nextImage($event)"><mat-icon>chevron_right</mat-icon></div>
        <div class="close-click" (click)="close()"><i class="material-icons notranslate">close</i></div>
        
        <img (click)="onEvent($event)" width="100%" src="{{image}}"/>
    </div>
</div>
